// A promo concerns a model if it has a model rule for it, or gives fixed/option discounts and doesn't exclude it.
export const promoAppliesTo = (p, modelId) => {
  if ((p.model_rules || {})[modelId]) return true;
  if ((p.no_option_promo_models || []).includes(modelId)) return false;
  return Object.keys(p.option_rules || {}).length > 0 || (p.model_amount_pub_ttc || 0) > 0 || (p.model_amount_res_ht || 0) > 0;
};
